import React from "react"
import {InnerWrapper} from "./components"

export type DefaultInnerWrapperProps = {
    children: React.ReactNode
}

const DefaultInnerWrapper = ({children}: DefaultInnerWrapperProps) => <InnerWrapper>{children}</InnerWrapper>

export default DefaultInnerWrapper
